import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducer from './reducer';
import { RootState } from './types';
import { savePersistedState } from '../utils/persist';
import { getApplicantToken } from '../utils/applicantToken';
import { configureStore } from '@reduxjs/toolkit';

const middlewares = [];

middlewares.push(thunk);

if (process.env.NODE_ENV === 'development') {
  const logger = createLogger({
    stateTransformer: (state: RootState) => state.toJS(),
  });

  middlewares.push(logger);
}

const store = configureStore({ reducer, middleware: middlewares });

store.subscribe(() => {
  // Stamped with (a fingerprint of) the token the state belongs to, so another link never rehydrates it.
  savePersistedState(getApplicantToken(), store.getState().toJS());
});

export default store;
